// Green Gold Platform - Branding Configuration
// Modular branding: Green Gold as main brand, modules keep their identity

export const platformBranding = {
  // Main platform brand
  platform: {
    name: 'Green Gold',
    fullName: 'Green Gold Platform',
    tagline: 'Your Complete Business Suite',
    logo: '/greengold-logo.svg',
    favicon: '/greengold-favicon.ico',
    primaryColor: '#2D5016', // Green Gold green
    accentColor: '#D4AF37',  // Green Gold gold
    domain: 'greengold.global',
    supportEmail: 'support@greengold.global',
  },
  
  // Modules keep their identity and colors
  modules: {
    shopfather: {
      name: 'ShopFather',
      description: 'Store Management',
      icon: 'ShoppingCart',
      color: '#f97316', // orange-500
      path: '/shop',
    },
    labelforge: {
      name: 'LabelForge',
      description: 'Product Labels',
      icon: 'Tags',
      color: '#22c55e', // green-500
      path: '/labels',
    },
    sealydoc: {
      name: 'SealyDoc',
      description: 'HACCP Documentation',
      icon: 'FileText',
      color: '#3b82f6', // blue-500
      path: '/docs',
    },
  },
  
  // Technology attribution
  poweredBy: {
    name: 'ViaTecnologia',
    url: 'https://via-tech.org',
    logo: '/vt-logo-small.svg',
    showInFooter: true,
    showInHeader: false,
  },
};

export default platformBranding;
